import { useTrackEmbedderUsage } from '../hooks/useTrackEmbedder';
import { Provider } from 'react-redux';
import { RhumbProvider } from 'react-rhumb';
import historyAdapter from 'react-rhumb/historyAdapterV4';
import { Router } from 'react-router-dom';
import rhumbConfig from '../../rhumb-config.yaml';
import ResponsivenessProvider from '../responsiveness/ResponsivenessProvider';
import { GlobalStyle } from './GlobalStyles.styles';
import Routes from './Routes';
import { Application } from 'foundations-components/components/Application';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function AppComponent({
  store,
  history
}) {
  useTrackEmbedderUsage();
  return /*#__PURE__*/_jsx(Application, {
    name: "signup-ui-lego",
    children: /*#__PURE__*/_jsxs(Provider, {
      store: store,
      children: [/*#__PURE__*/_jsx(GlobalStyle, {}), /*#__PURE__*/_jsx(RhumbProvider, {
        config: rhumbConfig,
        history: historyAdapter(history),
        children: /*#__PURE__*/_jsx(ResponsivenessProvider, {
          children: /*#__PURE__*/_jsx(Router, {
            history: history,
            children: /*#__PURE__*/_jsx(Routes, {})
          })
        })
      })]
    })
  });
}